import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ourProduct.css';

function OurProducts() {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <div>
      <div className="product-container">
        <img 
          src="WebsiteDevelopment.png" 
          alt="Our Products"
          className="product-image"
        />
      </div>

      <div className="title-text-container"> 
        <h2 className="section-title">PT MARS ACME PERKASA</h2>
        <p className="section-text">We specialize in creating comprehensive IT solutions, including HRIS, ERP, pathfinding systems, and website development.</p>
      </div>

      <div className="card-container">
      <button className="card" /*onClick={() => handleNavigation('/product-1')}*/ >
          <img src="koka.jpg" alt="Product 1" className="card-image" />
          <h3 className="card-title">HRIS</h3>
        </button>
        <button className="card" /*onClick={() => handleNavigation('/product-1')}*/ >
          <img src="apsa.jpg" alt="Product 2" className="card-image" />
          <h3 className="card-title">ERP System Customized</h3>
        </button>
        <button className="card" /*onClick={() => handleNavigation('/product-1')}*/ >
          <img src="laks.jpg" alt="Product 3" className="card-image" />
          <h3 className="card-title">Way Finding Machine</h3>
        </button>
      </div>
    </div>
  );
}

export default OurProducts;
